/*
  Porties omrekenen op de receptpagina (uit de 2.0-versie).

  Zoekt in elk ingrediënt de hoeveelheid aan het begin ("100 g", "1,5",
  "½", "1/2", "1 ½" of "2-3"), meestal vetgedrukt, en rekent die om als je op
  + of − drukt. Er wordt altijd vanaf het origineel gerekend, dus heen
  en weer klikken geeft geen afrondingsfouten. Zonder JavaScript staat
  het recept er gewoon zoals het is ingevoerd.
*/
(function () {
  var BREUKEN = { '½': 0.5, '¼': 0.25, '¾': 0.75, '⅓': 1 / 3, '⅔': 2 / 3 };
  var GETAL = '(\\d+\\/\\d+|\\d+(?:[.,]\\d+)?(?:\\s*[½¼¾⅓⅔])?|[½¼¾⅓⅔])';
  var HOEVEELHEID = new RegExp('^(\\s*)' + GETAL + '(?:\\s*[-–]\\s*' + GETAL + ')?([\\s\\S]*)$');

  function naarGetal(tekst) {
    var deel = tekst.trim().match(/^(\d+)\/(\d+)$/);   // "1/2"
    if (deel) return +deel[2] ? deel[1] / deel[2] : NaN;
    var m = tekst.replace(',', '.').trim().match(/^(\d+(?:\.\d+)?)?\s*([½¼¾⅓⅔])?$/);
    if (!m) return NaN;
    return (m[1] ? parseFloat(m[1]) : 0) + (m[2] ? BREUKEN[m[2]] : 0);
  }

  // 0.5 -> "½", 1.5 -> "1 ½", 2.4 -> "2,4", 250 -> "250"
  function netjes(n) {
    if (n >= 10) return String(Math.round(n));
    var heel = Math.floor(n);
    var rest = n - heel;
    if (rest < 0.04) return String(heel);
    if (rest > 0.96) return String(heel + 1);
    var breuken = [[0.25, '¼'], [1 / 3, '⅓'], [0.5, '½'], [2 / 3, '⅔'], [0.75, '¾']];
    for (var i = 0; i < breuken.length; i++) {
      if (Math.abs(rest - breuken[i][0]) < 0.04) return heel ? heel + ' ' + breuken[i][1] : breuken[i][1];
    }
    return String(Math.round(n * 10) / 10).replace('.', ',');
  }

  function start() {
    var sectie = document.querySelector('[data-fts-ingredienten][data-porties]');
    if (!sectie) return;
    var basis = parseFloat(sectie.dataset.porties);
    var blok = sectie.querySelector('[data-fts-porties]');
    if (!basis || !blok) return;

    var hoeveelheden = [];
    sectie.querySelectorAll('li').forEach(function (li) {
      // de hoeveelheid staat in de eerste tekst met inhoud, vaak binnen <strong> of een link
      var loper = document.createTreeWalker(li, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) { return n.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP; }
      });
      var eerste = loper.nextNode();
      if (!eerste) return;
      var m = eerste.textContent.match(HOEVEELHEID);
      if (!m) return;
      var van = naarGetal(m[2]);
      var tot = m[3] ? naarGetal(m[3]) : null;
      if (isNaN(van)) return;
      var span = document.createElement('span');
      span.className = 'recept__hoeveelheid';
      span.dataset.van = van;
      if (tot !== null && !isNaN(tot)) span.dataset.tot = tot;
      span.textContent = m[2] + (m[3] ? '–' + m[3] : '');
      eerste.textContent = m[4];
      eerste.parentNode.insertBefore(document.createTextNode(m[1]), eerste);
      eerste.parentNode.insertBefore(span, eerste);
      hoeveelheden.push(span);
    });
    if (!hoeveelheden.length) return;

    blok.hidden = false;
    var uit = blok.querySelector('output');
    var nu = basis;
    blok.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-stap]');
      if (!knop) return;
      nu = Math.min(24, Math.max(1, nu + Number(knop.dataset.stap)));
      uit.textContent = nu;
      blok.classList.toggle('is-aangepast', nu !== basis);
      var f = nu / basis;
      hoeveelheden.forEach(function (s) {
        var v = netjes(s.dataset.van * f);
        s.textContent = s.dataset.tot ? v + '–' + netjes(s.dataset.tot * f) : v;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
